<template>
  <page style="height: 100vh; overflow: hidden">
    <!-- 恢复原版头部：左侧菜单图标 + App 名称，点击打开侧边菜单 -->
    <div v-if="isRentalView" slot="nav" class="rental-head" @click="isMenuView = true">
      <img src="../assets/imgs/menu.png" alt="" />
      {{ title }}
    </div>
    <div v-if="!isRentalView" class="home-head" @click="isMenuView = true">
      <img class="home-logo" src="../assets/imgs/img_logo.png" alt="" />
      <!-- <div class="home-head-title">
        <p class="home-head-title-small">Welcome to</p>
        <p class="home-head-title-big"></p>
      </div> -->
    </div>
    <div>
      <div class="home-warp" v-if="isRentalView">
        <div class="banner" :style="banner"></div>
        <div class="home-warp-main">
          <div class="home-warp-block"></div>
          <div class="home-warp-cont">
            <div class="home-warp-title">
              <img src="../assets/imgs/map.png" alt="" />
              <span>{{ cabinet.shopname }}</span>
            </div>
            <div class="home-warp-jifei" v-html="priceStrategy(cabinet)"></div>
            <div class="home-warp-row">{{ shopDesc }}</div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_phone.png" alt="" />
              {{ i18n.feature_1 }}
            </div>
            <div class="home-warp-row">
              <img src="../assets/imgs/icon_star.png" alt="" />
              {{ i18n.feature_2 }}
            </div>
            <!-- <div class="home-warp-row">
              <img src="../assets/imgs/icon_tag.png" alt="">
              {{i18n.feature_3}}
            </div> -->
          </div>
          <div class="home-warp-btn">
            <!-- <div class="home-warp-btn" v-if="cabinet.chongzhi === 'Y'"> -->
            <!-- <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips1 }}</span>
            </div> -->
            <div
              class="btn"
              v-if="cabinet.yajintype === 0 && cabinet.yajin > 0"
              @click="onSubmit"
            >
              {{ i18n.submit }} {{ cabinet.currencyName }}{{ amount }}
              {{ cabinet.currency }}
            </div>
            <div v-else class="btn" @click="onSubmit">
              {{ i18n.borrow }} {{ cabinet.currencyName }}{{ amount }}
              {{ cabinet.currency }}
            </div>
          </div>
          <!-- <div class="home-warp-btn" v-else>
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips3 }}</span>
            </div>
            <!- <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div> ->
          </div> -->
        </div>
      </div>
      <!-- 对齐 App home：logo + 邀请卡 + 2x2 菜单 + 底部 tab（接入公共组件 BottomNav） -->
      <div v-else class="home-app">
        <div class="home-app-scroll">
          <div class="home-app-logo">
            <img src="../assets/imgs/img_logo.png" alt="" />
          </div>
          <!-- 邀请卡 -->
          <div class="home-app-invite" @click="onInvite">
            <img class="home-app-invite-bg" src="../assets/imgs/home_invite_card.png" alt="" />
            <div class="home-app-invite-text">
              <div class="home-app-invite-title">{{ i18n.invite_card_title }}</div>
              <div class="home-app-invite-tips">{{ i18n.invite_card_tips }}</div>
            </div>
          </div>
          <!-- 2x2 菜单 -->
          <div class="home-app-grid">
            <div class="home-app-row">
              <div class="home-app-card" @click="goMap">
                <div class="home-app-card-head">
                  <img src="../assets/imgs/home_icon_map.png" alt="" />
                  <img src="../assets/imgs/home_icon_path.png" alt="" class="home-app-card-arrow" />
                </div>
                <div class="home-app-card-title">{{ i18n.home_map }}</div>
                <div class="home-app-card-tips">{{ i18n.home_map_tips }}</div>
              </div>
              <div class="home-app-card" @click="goShop">
                <div class="home-app-card-head">
                  <img src="../assets/imgs/home_icon_shop.png" alt="" />
                  <img src="../assets/imgs/home_icon_path.png" alt="" class="home-app-card-arrow" />
                </div>
                <div class="home-app-card-title">{{ i18n.home_return }}</div>
                <div class="home-app-card-tips">{{ i18n.home_return_tips }}</div>
              </div>
            </div>
            <div class="home-app-row">
              <div class="home-app-card" @click="goOrder">
                <div class="home-app-card-head">
                  <img src="../assets/imgs/home_icon_order.png" alt="" />
                  <img src="../assets/imgs/home_icon_path.png" alt="" class="home-app-card-arrow" />
                </div>
                <div class="home-app-card-title">{{ i18n.order_title }}</div>
                <div class="home-app-card-tips">{{ i18n.home_order_tips }}</div>
              </div>
              <div class="home-app-card" @click="goHelp">
                <div class="home-app-card-head">
                  <img src="../assets/imgs/home_icon_help.png" alt="" />
                  <img src="../assets/imgs/home_icon_path.png" alt="" class="home-app-card-arrow" />
                </div>
                <div class="home-app-card-title">{{ i18n.home_faq }}</div>
                <div class="home-app-card-tips">{{ i18n.home_faq_tips }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部 tab bar（接入公共组件 BottomNav；主页 tab 已指向 /map，本页为租借结果页不高亮） -->
        <bottom-nav @scan="onScanClick"></bottom-nav>
      </div>
      <popup-warp v-model="isMenuView" dialogTransition="slide-left">
        <mine-side></mine-side>
      </popup-warp>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { PopupWarp } from "../components/popup"
// 抽屉内容：抽屉用「我的页面」（无底部栏），替代旧 MenuSide（side.vue 保留但不使用）
import MineSide from "../views/setting/mine_side.vue"
import BottomNav from "../components/common/BottomNav.vue"
import { QR_CODE, ZH_CODE, ORDER_TEMP } from "../apis/cabinet"
import { USER_INFO, USER_CARD } from "../apis/user"

import { SAVED_CARD_TO_RENT } from "../apis/payment"

export default {
  components: {
    PopupWarp,
    MineSide,
    BottomNav
  },
  computed: {
    ...mapState(["qrcode", "zhcode", "cabinet", "browser", "user", "system", "safeArea"]),
    // 租借详情态（home?cabinetshow=true 扫码进入）
    isRentalView() {
      return this.isScan && this.cabinet && !this.isBtns
    },
    // 原版头部标题：App 名称
    title() {
      return process.env.VUE_APP_NAME
    },
    i18n() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    code() {
      return this.qrcode || this.zhcode
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}&usePriceUnit=true`
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ""
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : ""
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format(this.cabinet)
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet)
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet)
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet)
    },
    homebg() {
      return `${process.env.VUE_APP_DOMAIN}/content/introduction1.png`
    },
    amount() {
      const { yajin, overtimeAmount } = this.cabinet
      let amount = yajin >= overtimeAmount ? yajin : overtimeAmount
      return amount
      // if (this.cabinet) {
      //   const { yajin, myyue, overtimeAmount } = this.cabinet
      //   let _amount = yajin.toFixed(2)
      //   if (yajin <= 0 && overtimeAmount <= 0) {
      //     _amount = (yajin - myyue).toFixed(2)
      //   }
      //   return _amount
      // } else {
      //   return 0
      // }
    }
  },
  data() {
    return {
      isMenuView: false,
      isScan: false,
      isBtns: false,
      checked: true,
      adVisible: false,
      downloadApp: false,
      downType: "",
      cardList: [] // 支付的卡列表
    }
  },
  methods: {
    Download(str) {
      this.downloadApp = true
      this.downType = str
    },
    handleDown() {
      if (this.downType === "App") {
        this.onAppStore()
      } else {
        this.onGooglePlay()
      }
    },
    onScan() {
      if (!this.scanUrl) return
      this.$loading(true)
      this.$post(
        this.scanUrl,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.isScan = true
            this.isBtns = false
            this.adVisible = true
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    goConfirmPage(paymentWay, shortfall = {}) {
      const { cabinetID = "", yajintype = "", overtimeAmount = 0 } = this.cabinet || {}
      let price = this.amount
      let balance = ""
      // 需冻结金额 = 押金与超时金额取大，与支付通道无关；
      // 后端 needRechargeAmount 只覆盖优惠后押金的差额，超时金额高于押金时在此补上超出部分
      if (Number(shortfall.needRechargeAmount) > 0) {
        const depositAmount = Number(shortfall.depositAmount || 0)
        const overTimeExtra =
          Number(overtimeAmount) > depositAmount
            ? Number(overtimeAmount) - depositAmount
            : 0
        price = Number(
          (Number(shortfall.needRechargeAmount) + overTimeExtra).toFixed(2)
        )
        balance = shortfall.balance || ""
      }
      this.$router.push({
        path: "/confirm",
        query: {
          paymentWay,
          payType: "YJ",
          price,
          balance,
          // 预授权通道冻结的是卡上的额度、不经过钱包余额，仍需按全额授权
          fullAmount: this.amount,
          cabinetID: cabinetID,
          yaJinType: yajintype,
          // 补差租借：将 qrcode 透传到确认页，充值成功后后端自动弹宝建租借订单
          qrcode: this.code
        }
      })
    },
    onSubmit() {
      this.$store.commit("wallet", null)
      // 余额是否足以支付押金改由后端判定：useBalanceToRent 余额不足时只返回需补足的差额，
      // 不产生任何扣减，前端不再用 myyue 与押金比较来猜测，避免有余额仍支付全额押金
      return this.onBorrow()
      // /***
      //  *不支持租借模式
      // 保存卡
      // var _isUserCard = this.cardList.length > 0
      // const goSaveCard = () => {
      //   this.$router.push({
      //     path: "/payment_card",
      //     query: { rentSave: true }
      //   })
      // }

      // // 卡授权 - 押金金额 = 0 && 超时金额 > 0
      // if (yajin <= 0 && overtimeAmount > 0) {
      //   if (!_isUserCard) return goSaveCard()
      //   return this.saveToRent()
      // }
      // // 押金金额 > 0
      // if (yajin > 0) {
      //   // 预授权 - 押金金额 == 超时金额
      //   if (overtimeAmount === yajin) {
      //     this.goConfirmPage("PAYMENT_PROPAY")
      //   }
      //   // 预授权+卡授权 - 超时金额 > 押金金额
      //   if (overtimeAmount > yajin) {
      //     if (!_isUserCard) return goSaveCard()
      //     this.goConfirmPage("PAYMENT_SAVED_PROPAY")
      //   }
      // }
      // */
    },
    onBorrow() {
      this.$loading(true)
      this.$get(
        // `${ORDER_TEMP}/${this.cabinet.qrcode}/paypal`,
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          const data = resp.data || {}
          if (data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${data.outTradNo}&shopid=${this.cabinet.shopid}`
            )
          } else if (Number(data.needRechargeAmount) > 0) {
            // 余额不足以支付优惠后押金，跳收银台只补差额
            this.goConfirmPage("PAYMENT_PROPAY", data)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        (resp) => {
          if (resp.user) {
            this.$store.commit("user", resp.user)
            this.onScan()
          } else {
            this.$store.commit("user", null)
          }
        },
        (error) => {
          this.$store.commit("user", null)
          console.log(error)
        }
      )
    },
    onAppStore() {
      console.log("11111")
      window.open(process.env.VUE_APP_APP_STORE)
      // window.location.href = process.env.VUE_APP_APP_STORE
    },
    onGooglePlay() {
      console.log("22222")
      window.open(process.env.VUE_APP_GOOGLE_PLAY)
      // window.location.href = process.env.VUE_APP_GOOGLE_PLAY
    },
    onCode() {
      this.isBtns = false
      this.loadUser()
    },
    onEntrust() {
      console.log("test", process.env.VUE_APP_DOMAIN_NAME)
      window.location.href = `${process.env.VUE_APP_DOMAIN_NAME}/content/wxf_auth.html`
    },
    goNearby() {
      this.$router.push("./google_map")
    },
    setDocumentTitle(title) {
      document.title = title
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement("iframe")
        i.src = "/favicon.ico"
        i.style.display = "none"
        i.onload = function () {
          setTimeout(function () {
            i.remove()
          }, 9)
        }
        document.body.appendChild(i)
      }
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true)
      const qrcode = this.qrcode || (this.cabinet && this.cabinet.qrcode)
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode,
        orderId: "",
        agentld: this.agentId
      })
      let cardList = []
      if (data && data.length) {
        cardList = data.map((item) => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          }
        })
        this.cardList = cardList
      }
      this.$loading(false)
      return cardList
    },
    saveToRent() {
      this.$loading(true)
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.out_trade_no) {
            this.$router.replace(
              `/result?&payMode=${this.payMode}&tradeNo=${resp.data.out_trade_no}`
            )
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    // 价格策略
    priceStrategy(cabinet = {}) {
      const strategy = cabinet.priceStrategy || {}
      let keepT = this.i18n.minute
      // 计时 pPriceMinute  单位 priceUnit 0-分钟 1-小时 2-天
      if (strategy.priceUnit === 1) {
        keepT = this.i18n.hour
      } else if (strategy.priceUnit === 2) {
        keepT = this.i18n.days
      }
      const price = `<span>${cabinet.currencyName + cabinet.jifei}</span>`
      return `${price} / ${cabinet.jifeiDanwei}${keepT}`
    },
    // 对齐 App home：菜单跳转
    onInvite() {
      this.$toast(this.i18n.invite_card_title || "Invite")
    },
    goMap() {
      this.$router.push("/map")
    },
    goShop() {
      this.$router.push("/shop")
    },
    goOrder() {
      this.$router.push("/order")
    },
    goHelp() {
      this.$router.push("/help")
    },
    goMine() {
      if (this.user) {
        this.$router.push("/setting")
      } else {
        this.$router.push("/login")
      }
    },
    onScanClick() {
      this.$toast(this.i18nMsg.appoffline || "Please use the cabinet to scan")
    }
  },
  created() {
    console.log("类型", this.browser, "1")
    this.isBtns = true
    if (this.$route.query && this.$route.query.cabinetshow === "true") {
      this.isScan = true
      this.isBtns = false
      this.adVisible = true
    }
    // 带 qrcode/zhcode 进入时自动发起租借查询，切换到租借页
    if (this.code) {
      this.loadUser()
    }
  },
  mounted() {
    this.getUserPayCard()
  }
}
</script>

<style lang="less">
.home-head {
  width: 100%;
  font-size: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  // margin: 20px 0 0;
  padding: 46px 60px;

  .home-logo {
    width: 300px;
  }

  &-title {
    p {
      text-align: end;
      margin: 10px 0;
    }

    &-small {
      font-family: "Montserrat-Medium";
      font-size: 24px;
      color: #171917;
    }

    &-big {
      font-family: "Montserrat-SemiBold";
      font-size: 36px;
      font-weight: 500;
      color: var(--text-main);
    }
  }
}

// 租借详情头部：恢复原版规格（高 88px / 菜单图标 52x52 左 32px 垂直居中 / App 名称居中）
// 头部为透明白底，menu.png 实为白色图标，标题与图标均需转深色才可见
.rental-head {
  position: relative;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  color: #171917;
  cursor: pointer;

  img {
    height: 52px;
    width: 52px;
    position: absolute;
    left: 32px;
    top: 50%;
    transform: translateY(-50%);
    // menu.png 为白色图标，brightness(0) 转黑色以在白底上可见
    filter: brightness(0);
  }
}

.home-warp {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }

  &-main {
    width: 100%;
    height: calc(100vh - 454px);
    position: fixed;
    bottom: 0;
    left: 0;
    // 对齐 App borrow 页：白色卡片 cardColor，顶部圆角 50 -> 87px
    background: var(--page-bg);
    border-radius: 87px 87px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }

  &-block {
    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }

  &-cont {
    padding: 0 @page-padding;
  }

  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    // 对齐 App borrow：shopname 字号 20 粗体黑色
    span {
      font-size: 35px;
      font-weight: bold;
      color: var(--text-main);
    }
  }

  &-jifei {
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;

    span {
      font-size: 60px;
    }
  }

  &-row {
    display: flex;
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    // 对齐 App：列表项正文 textColor 黑色
    color: var(--text-sub);

    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }

  &-btn {
    position: fixed;
    left: @page-padding;
    right: @page-padding;
    bottom: 48px;

    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }

  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: var(--text-sub);
    padding: 20px 0;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}

.home-bg {
  width: 60%;
  display: block;
  margin: 0px auto;
  // height: 100vh;
}

.home-btns {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 40px;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  z-index: -1;

  a {
    text-decoration: none;
    width: 30%;
    flex: 1;
    margin: 20px;
    // 对齐 App 第三方按钮背景 cardBlackWhite(#231F20)
    background: var(--dark);
    color: #ffffff;
    padding: 20px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}

.downloaddark {
  display: flex;
  justify-content: space-between;
  margin: 0 60px;

  .icondark {
    width: 40%;

    img {
      display: block;
      width: 90%;
    }

    img:last-child {
      margin-top: 20px;
    }
  }

  .next {
    width: 40%;
    // 对齐 App 主按钮字体：Montserrat-Medium
    font-family: @font-medium;
    font-weight: bold;
    font-size: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    // 对齐 App 主题色
    background: var(--theme-color);
    border-radius: @radius-btn;
    padding: 0px 20px;

    .text {
      // line-height: 64px;
      display: block;
    }

    img {
      width: 64px;
      height: 64px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }
}

.go-code {
  text-align: center;
  color: var(--theme-color);
  text-decoration: underline;
  padding: 10px 0 30px;
}

.home-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;

  .nearby {
    position: absolute;
    bottom: 170px;
    right: 20px;
    color: #fff;
    text-decoration: underline;
    text-align: center;
  }
}

.borrow-wechat-zff {
  display: flex;
  justify-content: center;
  padding: 20px 0 4px;

  img {
    height: 34px;
  }
}

.home-checkbox {
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;

  .home-checkbox-text {
    color: var(--text-main);
  }

  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
  }

  input[type="checkbox"]::after {
    position: absolute;
    top: 0;
    background-color: #fff;
    color: #fff;
    width: 28px;
    height: 28px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: " ";
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #ddd;
  }

  input[type="checkbox"]:checked::after {
    content: "";
    // 对齐 App 主题色勾选框
    background-color: var(--theme-color);
    border-color: var(--theme-color);
    background-color: var(--theme-color);
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 10px;
    width: 6px;
    height: 16px;
    border: solid white;
    border-width: 0 4px 4px 0;
    transform: rotate(45deg);
    z-index: 1;
  }
}

.home-head {
  display: none !important;
}

.home-mine {
  width: 90px;
  height: 60px;
  line-height: 30px;
  padding: 15px 0;
  font-size: 28px;
  text-align: center;
  position: fixed;
  right: 40px;
  bottom: 350px;
  z-index: 99;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 8px 24px 0 rgba(52, 125, 255, 0.32);
  // img {
  //   width: 100%;
  //   height: 100%;
  //   border-radius: 50%;
  // }
}

// 对齐 App home.dart：logo + 邀请卡 + 2x2 菜单 + 底部 tab
.home-app {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--page-bg);
  padding: 26px 30px 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

// 可滚动区域（logo + 邀请卡 + 菜单）
.home-app-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 18px;
}

.home-app-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin-bottom: 18px;
  flex-shrink: 0;

  img {
    width: 180px;
    height: auto;
    display: block;
  }
}

// 邀请卡
.home-app-invite {
  width: 100%;
  margin: 17px 0 18px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;

  &-bg {
    width: 100%;
    display: block;
  }

  &-text {
    position: absolute;
    top: 23px;
    left: 17px;
    right: 17px;
  }

  &-title {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    font-family: "Montserrat-SemiBold";
  }

  &-tips {
    color: #fff;
    font-size: 18px;
    margin-top: 8px;
    font-family: "Montserrat-Medium";
  }
}

// 2x2 菜单
.home-app-grid {
  width: 100%;
  flex: 1;
}

.home-app-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;

  &:last-child {
    margin-bottom: 0;
  }
}

.home-app-card {
  flex: 1;
  height: 240px;
  background: #f8f6fc;
  border-radius: 18px;
  padding: 32px 24px;
  box-sizing: border-box;

  & + & {
    margin-left: 14px;
  }

  &-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    img {
      width: 72px;
      height: 72px;
      display: block;
    }
  }

  &-arrow {
    width: 68px !important;
    height: 68px !important;
  }

  &-title {
    margin-top: 8px;
    font-family: "Montserrat-SemiBold";
    font-size: 32px;
    font-weight: 900;
    color: #171917;
  }

  &-tips {
    font-family: "Montserrat-Medium";
    font-size: 24px;
    font-weight: 600;
    color: #171917;
    margin-top: 4px;
  }
}

// 底部 tab 已抽出为公共组件 components/common/BottomNav.vue，此处不再保留旧样式
</style>
